import React, { useEffect, useState } from 'react';
import '../pages/certificates.css';

const CertificateForm = ({ certificate, onSave, onCancel }) => {
  const [form, setForm] = useState({
    title: '',
    issuer: '',
    issued_at: '',
    link: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (certificate) setForm(certificate);
  }, [certificate]);

  const validate = () => {
    const e = {};
    if (!form.title.trim()) e.title = 'Title required';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = (e) => {
    e.preventDefault();
    if (validate()) onSave(form);
  };

  return (
    <form onSubmit={submit} className="cert-form">
      <h3>{certificate ? 'Edit Certification' : 'Add Certification'}</h3>

      <label>
        Title
        <input
          value={form.title}
          onChange={e => setForm({ ...form, title: e.target.value })}
          placeholder="Google Project Management"
        />
        {errors.title && <span className="error">{errors.title}</span>}
      </label>

      <label>
        Issuer
        <input
          value={form.issuer}
          onChange={e => setForm({ ...form, issuer: e.target.value })}
          placeholder="Google"
        />
      </label>

      <label>
        Issued Date
        <input
          type="date"
          value={form.issued_at || ''}
          onChange={e => setForm({ ...form, issued_at: e.target.value })}
        />
      </label>

      <label>
        Certificate URL
        <input
          value={form.link}
          onChange={e => setForm({ ...form, link: e.target.value })}
          placeholder="https://..."
        />
      </label>

      <div className="modal-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn-primary">
          {certificate ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  );
};

export default CertificateForm;
